import React from 'react';

import BooleanInput from 'bundles/apex/custom_fields/form/boolean';
import DealField, { propTypes } from './field';

export function BooleanDealField({ changeDeal, deal, invalid, label, name, required }) {
  return (
    <BooleanInput
      hasError={invalid}
      label={label}
      name={name}
      required={required}
      value={deal[name]}
      onChange={changeDeal}
    />
  );
}

BooleanDealField.propTypes = propTypes;

export default DealField(BooleanDealField);
